(ns common.i18n
  (:require
   [opengb.i18n.macros])
  #?(:cljs (:require [shadow.resource :as rc])))

;; Use `inline` so that shadow-cljs picks up changes to the translations csv files
;; See: https://clojureverse.org/t/using-none-code-resources-in-cljs-builds/3745/6
#?(:cljs
   (do (rc/inline "translations/hop-translations.csv")
       (rc/inline "translations/hop-translations-saskatoon.csv")
       (rc/inline "translations/hop-translations-test-tenant.csv")
       (rc/inline "translations/hop-translations-toronto.csv")
       (rc/inline "translations/hop-translations-uat_toronto.csv")))

(def ^:private dictionaries
  {:default      (opengb.i18n.macros/load-translations "translations/hop-translations.csv")
   "saskatoon"   (opengb.i18n.macros/load-translations "translations/hop-translations-saskatoon.csv")
   "test_tenant" (opengb.i18n.macros/load-translations "translations/hop-translations-test-tenant.csv")
   "toronto"     (opengb.i18n.macros/load-translations "translations/hop-translations-toronto.csv")
   "uat_toronto" (opengb.i18n.macros/load-translations "translations/hop-translations-uat_toronto.csv")})

(defn get-dictionaries
  [tenant-slug]
  (let [default (get dictionaries :default)
        tenant  (get dictionaries tenant-slug)]
    (merge-with merge default tenant)))
